export enum CinemaApiEmbed {
    CINEMA_CONFIGURATION = 'cinemaConfiguration',
    METRIC_CUSTOMER_COUNT = 'metricCustomersCount',
    METRIC_COMPARE_USER_COUNT = 'metricCompareUserCount',
    METRIC_CUSTOMERS_TOTAL_COUNT = 'metricCustomersTotalCount',
    METRIC_ROOM_COUNT = 'metricRoomCount',
    METRIC_SEAT_COUNT = 'metricSeatCount'
}
